import * as Turbo from "@hotwired/turbo";
Turbo.start();

import Rails from '@rails/ujs';

import HotelRewardsOverview from "@/components/RewardsOverview/HotelRewardsOverview";
import React from "react";
import ReactDOM from "react-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

document.addEventListener("turbo:load", () => {
  const el = document.getElementById("hotel-rewards-overview");
  const propsScript = document.getElementById("hotel-rewards-overview-props");

  if (el && propsScript) {
    try {
      const props = JSON.parse(propsScript.textContent || "{}");
      ReactDOM.render(React.createElement(HotelRewardsOverview, props), el);
    } catch (e) {
      console.error("Failed to parse props JSON:", e);
    }
  }
});
